import {SET_LANG} from "../actions/lang";

const initialState = {
    code : 'fa',
    isoCode: 'fa_IR'
};

export default function langReducer(state = initialState , action = {}){
    switch (action.type) {
        case SET_LANG :
            const { lang } = action;
            return {
                code : lang.code,
                isoCode: lang.isoCode,
            };
            // break;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/lang.js